import React, {Component} from "react";
import {browserHistory} from 'react-router';
import I18n from 'lib/i18n/i18n';
import UserActions from 'lib/userActions';
import WorthyApi from "lib/api/worthyApi";
import Properties from 'components/item/properties';
import {dataAutomationAttr, dollarsWithoutCents, isTablet} from 'helpers/ApplicationHelper';
import Popup from 'components/popups/popup';
import {PopupSimilarItems} from 'components/popups/popupSimilarItems';
import PopupTooltipSuccessFee from "components/popups/popupTooltipSuccessFee";
import SpecialProperties from "components/item/specialSaleFormats/specialProperties";

class PopupShipBack extends Popup {
    static initPopup(props = {}) {
        Popup.initPopup.bind(this)(props);
    }

    componentDidMount() {
        PendingSale.logEvent('ship back popup presented');
    }

    componentWillUnmount() {
        PendingSale.logEvent('ship back popup closed');
    }

    title() {
        return I18n.getString('itemPage::pendingSale::popups::shipBack::title');
    }

    content() {
        const linkText = I18n.getString('itemPage::pendingSale::popups::shipBack::CTAs::decline'),
            btnText = I18n.getString('itemPage::pendingSale::popups::shipBack::CTAs::confirm');
        return (
            <div>
                <div>{I18n.getString('itemPage::pendingSale::popups::shipBack::content')}</div>
                <div id="price-table">{this.priceTable()}</div>
                <button className="btn btn-orange" data-automation={dataAutomationAttr(btnText)} onClick={() => {
                    PendingSale.logEvent('ship back confirm button clicked');
                    WorthyApi.refuseSpecialSale(this.props.item.id).then(() => {
                        this.props.shipBack();
                        this._hide();
                    })
                }}>{btnText}</button>
                <div className="link-wrapper">
                    <a className="link" data-automation={dataAutomationAttr(linkText)} onClick={() => {
                        PendingSale.logEvent('ship back declined button clicked');
                        this._hide();
                    }}>{linkText}</a>
                </div>
            </div>
        );
    }

    priceTable() {
        const ret = [<h3 key=''>{`${this.props.item.type.toUpperCase()} PRICE`}</h3>];
        for (const subsetName in this.props.item.subset_values) {
            const subsetValue = this.props.item.subset_values[subsetName];
            ret.push(
                <p className="property" key={subsetName}>
                    <span className="subset">{subsetName}</span>
                    <span className="value">{dollarsWithoutCents(subsetValue)}</span>
                </p>
            );
        }
        return ret;
    }
}
PopupShipBack.defaultProps = {
    popupClassName: 'popup popup-compact popup-ship-back',
    single: true,
    modal: true,
    classNames: ['no-animation']
};

class PopupInfo extends Popup {
    static initPopup(props = {}) {
        Popup.initPopup.bind(this)(props);
    }

    componentDidMount() {
        PendingSale.logEvent('quick sale popup presented');
    }

    componentWillUnmount() {
        PendingSale.logEvent('quick sale popup closed');
    }

    title() {
        return this.props.format.toUpperCase().replace('_', ' ');
    }

    content() {
        return (
            <div>
                <div>{I18n.getString('itemPage::pendingSale::popups::info::content')}</div>
            </div>
        );
    }
}
PopupInfo.defaultProps = {
    popupClassName: 'popup popup-compact popup-tooltip popup-quick-sale',
    single: true,
    modal: true,
    classNames: ['no-animation']
};

class PopupSimilarItemsExt extends PopupSimilarItems {
    componentDidMount() {
        PendingSale.logEvent('similar items popup presented');
    }

    componentWillUnmount() {
        PendingSale.logEvent('similar items popup closed');
    }
}

class PendingSale extends Component {
    constructor(props) {
        super(props);

        this.state = {
            shipBack: this.props.item.ship_back
        }

        this.openShipBackPopup = this.openShipBackPopup.bind(this);
        this.shipBack = this.shipBack.bind(this);
    }

    static logEvent(event) {
        UserActions.pendingSale(event);
    }

    componentDidMount() {
        PendingSale.logEvent('page loaded');
    }

    render() {
        return this.state.shipBack ? this.renderShipBackPage() : this.renderPendingSalePage();
    }

    renderPendingSalePage() {
        const item = this.props.item,
            similarItemsLinkText = I18n.getString('itemPage::pendingSale::saleFormat::similarItemsLink'),
            shipBackLinkText = I18n.getString('itemPage::pendingSale::saleFormat::shipBackLink'),
            btnText = I18n.getString(`itemPage::pendingSale::saleFormat::boxes::box1::cta::${isTablet() ? 'tablet' : 'regular'}`);
        return (
            <div id="item-pending-quick-sale">
                <h3 className="title">{I18n.getString('itemPage::pendingSale::title')}</h3>
                <h2 className="item-desc">{item.desc}</h2>
                <div className="content">
                    <Properties item={item} showSellerNotes={false}/>
                    <div id="sale-format-choice">
                        <h3 className="inline">{I18n.getString('itemPage::pendingSale::saleFormat::title')}</h3>
                        <div className='sub'>{I18n.getString('itemPage::pendingSale::saleFormat::sub1')}</div>
                        <div className='sub'>
                            {
                                item.similar_items && item.similar_items.length && I18n.getJsx('itemPage::pendingSale::saleFormat::sub2', {
                                    similarItemsLink: <a className='link' data-automation={dataAutomationAttr(similarItemsLinkText)} onClick={() => {
                                        PendingSale.logEvent('similar items popup clicked');
                                        PopupSimilarItemsExt.initPopup({item: item});
                                    }}>{similarItemsLinkText}</a>,
                                    valueRange: <span>{`${dollarsWithoutCents(item.estimation.total.low)} - ${dollarsWithoutCents(item.estimation.total.high)}`}</span>
                                }) || null
                            }
                        </div>
                        <div id="option-boxes">
                            <div className="option-box">
                                <h5>{I18n.getString('itemPage::pendingSale::saleFormat::boxes::box1::title')}</h5>
                                <h4 className="inline">{I18n.getString(
                                    `itemPage::pendingSale::saleFormat::boxes::box1::subtitle::${this.props.item.format === 'quick_sale' ? 'quickSale' : 'assortedAuction'}`)}</h4>
                                <a className="help-btn" data-automation={dataAutomationAttr('popup-quick-sale')} onClick={() => {
                                    PendingSale.logEvent('quick sale popup clicked');
                                    PopupInfo.initPopup({format: this.props.item.format})
                                }}/>
                                <h3>{dollarsWithoutCents(this.props.item.evaluation_after_buyer_fees)}</h3>
                                <button className='btn btn-orange absolute' data-automation={dataAutomationAttr(btnText)} onClick={() => {
                                    PendingSale.logEvent('sell now button clicked');
                                    browserHistory.push(`/user/payment_details/item/${item.id}`);
                                }}>{btnText}</button>
                                {this.boxFooter(false, true)}
                            </div>
                            <div className="option-box">
                                <h5>{I18n.getString('itemPage::pendingSale::saleFormat::boxes::box2::title')}</h5>
                                <h4 className="inline">{I18n.getString('itemPage::pendingSale::saleFormat::boxes::box2::subtitle')}</h4>
                                <div className="red-box">
                                    <div className="red-box-content">{I18n.getString('itemPage::pendingSale::saleFormat::boxes::box2::redBox')}</div>
                                </div>
                                <button className="btn btn-orange" disabled={true}>
                                    {I18n.getString('itemPage::pendingSale::saleFormat::boxes::box2::cta')}
                                </button>
                                {this.boxFooter(true, false)}
                            </div>
                        </div>
                        <div className='link-wrapper'>
                            <a className="link" data-automation={dataAutomationAttr(shipBackLinkText)} onClick={this.openShipBackPopup}>{shipBackLinkText}</a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderShipBackPage() {
        return <SpecialProperties item={this.props.item} showSellerNotes={false} shipBack={true} />
    }

    boxFooter(disabled, absolute) {
        return (
            <div className={`footer-wrapper${absolute ? ' absolute ' : ''}${disabled ? ' disabled' : ''}`}>
                {this.successFees(disabled)}
            </div>
        )
    }

    successFees(disabled) {
        const linkText = I18n.getString('itemPage::pendingSale::saleFormat::successFeesLink'),
            onClick = () => {
                PendingSale.logEvent('success fees popup clicked');
                PopupTooltipSuccessFee.initPopup({
                    page: 'pending_sale',
                    openEvent: 'success fees popup presented',
                    closeEvent: 'success fees popup closed'
                })};
        return I18n.getJsx('itemPage::pendingSale::saleFormat::boxes::footerLink', {
            successFeesLink: <a className='link' data-automation={dataAutomationAttr(disabled ? null : linkText)} onClick={() => {
                !disabled && onClick();
            }}>{linkText}</a>
        })
    }

    openShipBackPopup() {
        PendingSale.logEvent('no thanks button clicked');
        PopupShipBack.initPopup({item: this.props.item, shipBack: this.shipBack, format: this.props.item.format})
    }

    shipBack() {
        this.setState({shipBack: true});
    }
}

export default PendingSale;
